import { put, takeEvery, all, select, putResolve } from "redux-saga/effects";
import { CFTNS, IS_AUTHENTICATED, LOGOUT, SPID, USER_INFO } from "./actionsType";

import { isAuthenticatedActionSuccess, logoutAction, userInfoAction, userInfoActionSuccess } from "./actions";
import { resetStateAction } from "../reset/actions";
import { userInfoSelector } from "./selectors";
import { ERRORE_SESSION_EXPIRED } from "../../global/messaggioLabels";
import { setMessaggioAction } from "../messaggio/actions";
import { handleIsAuthenticatedApiSPID, handleUserInfoApiSPID } from "../../api/apiFunctionsAuth";
import { profiloAriannaSelector } from "../screening/selectors";
import { ROOT } from "../../global/urlMapping";
import { generaLog } from "../../functions/utils";
import Cookies from 'js-cookie';

function* handleIsAuthenticatedWorker() {
    const profiloArianna = yield select(profiloAriannaSelector)
    const userInfo = yield select(userInfoSelector)
    generaLog("handleIsAuthenticatedWorker", "log")

    //LOGIN SALUTESIMPLEX
    const urlParams = new URLSearchParams(window.location.search)
    const codiceFiscale = urlParams.get('cf') ?? urlParams.get('CF');
    const tesseraSanitaria = urlParams.get('ts') ?? urlParams.get('TS')

    const codiceFiscaleCookie = Cookies.get(process.env.REACT_APP_COOKIE_CF);
    const tesseraCookie = Cookies.get(process.env.REACT_APP_COOKIE_TESSERA);

    try {
        //CFTNS
        if (sessionStorage.CFTNS && profiloArianna.status === 200)
            yield put(isAuthenticatedActionSuccess({ isAuthenticated: true, authType: CFTNS }))
        else if (sessionStorage.tempCFTNS || (codiceFiscale !== null || tesseraSanitaria !== null)
            || (codiceFiscaleCookie !== undefined || tesseraCookie !== undefined)) {
            console.log("...")
        }
        //GATEWAY
        else {
            const response = yield handleIsAuthenticatedApiSPID()
            if (response?.status === 200) {
                yield put(isAuthenticatedActionSuccess({ isAuthenticated: true, authType: SPID }))
                if (userInfo.status !== 200) {
                    //TEST
                    yield putResolve(userInfoAction())
                }
            }
            else {
                yield put(resetStateAction())
            }
        }
    } catch (error) {
        if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else if (sessionStorage.CFTNS) {
            yield putResolve(logoutAction())
            //handleLogout(authType);
        } else {
            yield put(resetStateAction())
        }
    }



}

function* handleIsAuthenticatedWatcher() {
    yield takeEvery(IS_AUTHENTICATED, handleIsAuthenticatedWorker)
}

function* handleUserInfoWorker() {//TODO
    generaLog("handleUserInfoWorker", "log")
    let response;
    try {
        if (sessionStorage.CFTNS) {
            //TODO
        } else {
            response = yield handleUserInfoApiSPID()

        }
        if (response?.status === 200) {
            yield put(userInfoActionSuccess({ value: response?.data, status: response?.status }))
        }
    } catch (error) {
        yield put(userInfoActionSuccess({ value: undefined, status: error?.response?.status }))
    }
}

function* handleUserInfoWatcher() {
    yield takeEvery(USER_INFO, handleUserInfoWorker)
}

function* handleLogoutWorker() {//TODO
    generaLog("handleLogoutWorker", "log")
    let response;

    if (sessionStorage.CFTNS) {
        sessionStorage.clear();
        yield put(resetStateAction())
        window.location.href = ROOT;
    } else {
        sessionStorage.clear();
        try {
            response = yield handleIsAuthenticatedApiSPID()
            if (response?.status === 200) {
                yield put(resetStateAction())
                window.location.href = process.env.REACT_APP_BASEURL_GW + "/auth/logoutUser?postLogoutUriCustom=" + ROOT
            }
            else {
                yield put(resetStateAction())
            }
        } catch (error) {
            yield put(resetStateAction())

        }
    }

}

function* handleLogoutWatcher() {
    yield takeEvery(LOGOUT, handleLogoutWorker)
}

export function* authWatchers() {
    yield all([
        handleIsAuthenticatedWatcher(),
        handleUserInfoWatcher(),
        handleLogoutWatcher(),
    ]);
}
